exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#PersonalDetails .picker-heading{padding-top:6px;font-size:28px;font-weight:500}#PersonalDetails .picker-heading,#PersonalDetails .picker-subheading{display:flex;justify-content:center;margin:0;color:#fff;background-color:hsl(var(--agency-hue),var(--agency-sat),var(--agency-lig))}#PersonalDetails .picker-subheading{padding-bottom:6px;font-family:Nunito,sans-serif}#PersonalDetails .niContainer{margin-bottom:20px;margin-left:20px}", ""]);

// exports
